<section class="flex min-h-72 flex-col" aria-label="Conteúdo dos módulos">
  <div class="flex flex-col">
    @for (moduleForm of modulesForm.controls; track moduleForm.controls.id.value; let index = $index) {
      <article
        class="border-b border-lGray800 last:border-b-0"
        [attr.aria-expanded]="isExpanded(moduleForm.controls.id.value)"
      >
        <button
          type="button"
          class="flex w-full items-center justify-between gap-4 bg-transparent py-5 text-left"
          [attr.aria-controls]="'module-content-' + moduleForm.controls.id.value"
          (click)="toggleModule(moduleForm.controls.id.value)"
        >
          <div class="flex min-w-0 flex-1 items-center gap-3">
            <span class="shrink-0 rounded-lg bg-lGray950 px-3 py-1.5 text-base font-semibold leading-6 text-lWhite">
              Módulo {{ index + 1 }}
            </span>
            <span class="truncate text-base leading-6 text-lWhite">{{ getModuleTitle(moduleForm) }}</span>
          </div>

          <div class="flex shrink-0 items-center gap-2">
            @if (isModuleContentComplete(moduleForm.controls.id.value)) {
              <span
                class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-lSuccess"
                aria-hidden="true"
              >
                <l-icon class="!text-xl leading-none text-white">check</l-icon>
              </span>
            } @else {
              <span
                class="inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-lContentWarning text-lContentWarning"
                [pTooltip]="getModuleContentStatusTooltip(moduleForm.controls.id.value)"
                tooltipPosition="top"
                tooltipStyleClass="status-info-tooltip"
                [attr.aria-label]="getModuleContentStatusTooltip(moduleForm.controls.id.value)"
                (click)="$event.stopPropagation()"
              >
                <l-icon class="!text-sm leading-none">priority_high</l-icon>
              </span>
            }

            <span
              class="inline-flex text-lGray500 transition-transform duration-300 ease-in-out will-change-transform"
              [style.transform]="isExpanded(moduleForm.controls.id.value) ? 'rotate(180deg)' : 'rotate(0deg)'"
            >
              <l-icon class="text-2xl font-light">expand_more</l-icon>
            </span>
          </div>
        </button>

        <div
          class="grid transition-[grid-template-rows] duration-300"
          [ngClass]="{
            'grid-rows-[1fr]': isExpanded(moduleForm.controls.id.value),
            'grid-rows-[0fr]': !isExpanded(moduleForm.controls.id.value)
          }"
        >
          <div class="overflow-hidden">
            <fieldset
              [id]="'module-content-' + moduleForm.controls.id.value"
              class="m-0 flex w-full flex-col gap-4 border-0 p-0 pb-5"
              [attr.aria-label]="'Ações do módulo ' + (index + 1)"
            >
              @if (getModuleClasses(moduleForm).length > 0) {
                <ul
                  cdkDropList
                  class="drag-sort-list m-0 flex list-none flex-col gap-3 p-0"
                  [cdkDropListData]="getModuleClasses(moduleForm)"
                  aria-label="Lista de conteúdos do módulo"
                  (cdkDropListDropped)="onContentReordered(moduleForm, $event)"
                  (cdkDropListSorted)="onContentListSorted(moduleForm.controls.id.value, $event)"
                >
                  @for (courseClassForm of getModuleClasses(moduleForm); track courseClassForm.controls.id.value) {
                    <li
                      cdkDrag
                      [attr.data-content-card-id]="courseClassForm.controls.id.value"
                      cdkDragLockAxis="y"
                      class="drag-sort-item block w-full"
                      [cdkDragData]="courseClassForm"
                      (cdkDragStarted)="onDragStartedForContent(moduleForm.controls.id.value, courseClassForm.controls.id.value)"
                      (cdkDragEnded)="onContentDragEnded(moduleForm.controls.id.value)"
                    >
                      <l-sortable-card
                        [active]="isContentCardActive(courseClassForm.controls.id.value)"
                        [dragging]="isDraggingContent(moduleForm.controls.id.value, courseClassForm.controls.id.value)"
                        dragHandleAriaLabel="Reordenar conteúdo"
                      >
                        <span class="shrink-0 text-sm font-medium text-lGray50">
                          Conteúdo {{ getContentDisplayIndex(moduleForm.controls.id.value, courseClassForm.controls.id.value) }}
                        </span>
                        <input
                          type="text"
                          class="h-12 min-w-0 flex-1 rounded-2xl border-0 px-4 text-base outline-none transition-colors duration-200 placeholder:text-lGray600"
                          [class.bg-lGray950]="!isContentCardActive(courseClassForm.controls.id.value)"
                          [class.text-lGray500]="!isContentCardActive(courseClassForm.controls.id.value)"
                          [class.bg-lGray700]="isContentCardActive(courseClassForm.controls.id.value)"
                          [class.text-lWhite]="isContentCardActive(courseClassForm.controls.id.value)"
                          [formControl]="courseClassForm.controls.name"
                          [attr.aria-label]="'Nome do conteúdo ' + getContentDisplayIndex(moduleForm.controls.id.value, courseClassForm.controls.id.value)"
                          placeholder="Digite o nome do conteúdo"
                          (click)="setActiveContentCard(courseClassForm.controls.id.value)"
                          (focus)="setActiveContentCard(courseClassForm.controls.id.value)"
                        />

                        <div sortableCardActions>
                          @if (isContentCardActive(courseClassForm.controls.id.value)) {
                            <button
                              type="button"
                              class="flex shrink-0 items-center justify-center text-lWhite transition-opacity hover:opacity-80"
                              aria-label="Editar conteúdo"
                              (click)="setActiveContentCard(courseClassForm.controls.id.value)"
                            >
                              <l-icon class="text-2xl">edit</l-icon>
                            </button>
                          } @else {
                            <button
                              type="button"
                              class="flex shrink-0 items-center justify-center text-lDanger transition-opacity hover:opacity-80"
                              aria-label="Excluir conteúdo"
                              (click)="onDeleteContent(moduleForm, courseClassForm.controls.id.value)"
                            >
                              <l-icon class="text-xl">delete</l-icon>
                            </button>
                          }
                        </div>
                      </l-sortable-card>

                      <ng-template cdkDragPlaceholder>
                        <l-sortable-card [ghost]="true" dragHandleAriaLabel="Reordenar conteúdo">
                          <span class="shrink-0 text-sm font-medium text-lGray50">
                            Conteúdo {{ getContentDisplayIndex(moduleForm.controls.id.value, courseClassForm.controls.id.value) }}
                          </span>
                          <input
                            type="text"
                            class="h-12 min-w-0 flex-1 rounded-2xl border-0 bg-lGray950 px-4 text-base text-lGray50 outline-none placeholder:text-lGray600"
                            [formControl]="courseClassForm.controls.name"
                            tabindex="-1"
                            readonly
                            aria-hidden="true"
                          />
                          <span
                            sortableCardActions
                            class="invisible flex shrink-0 items-center justify-center text-lDanger"
                            aria-hidden="true"
                          >
                            <l-icon class="text-xl">delete</l-icon>
                          </span>
                        </l-sortable-card>
                      </ng-template>

                      <ng-template cdkDragPreview matchSize>
                        <l-sortable-card [preview]="true" dragHandleAriaLabel="Reordenar conteúdo">
                          <span class="shrink-0 text-sm font-medium text-lGray50">
                            Conteúdo {{ getContentDisplayIndex(moduleForm.controls.id.value, courseClassForm.controls.id.value) }}
                          </span>
                          <input
                            type="text"
                            class="h-12 min-w-0 flex-1 rounded-2xl border-0 bg-lGray700 px-4 text-base text-lWhite outline-none placeholder:text-lGray500"
                            [formControl]="courseClassForm.controls.name"
                            tabindex="-1"
                            readonly
                            aria-hidden="true"
                          />
                          <span
                            sortableCardActions
                            class="flex shrink-0 items-center justify-center text-lDanger"
                            aria-hidden="true"
                          >
                            <l-icon class="text-xl">delete</l-icon>
                          </span>
                        </l-sortable-card>
                      </ng-template>
                    </li>
                  }
                </ul>
              }

              @if (getModuleEvaluations(moduleForm).length > 0) {
                <ul
                  cdkDropList
                  class="drag-sort-list m-0 flex list-none flex-col gap-3 p-0"
                  [cdkDropListData]="getModuleEvaluations(moduleForm)"
                  aria-label="Lista de avaliações do módulo"
                  (cdkDropListDropped)="onEvaluationReordered(moduleForm, $event)"
                  (cdkDropListSorted)="onEvaluationListSorted(moduleForm.controls.id.value, $event)"
                >
                  @for (evaluationForm of getModuleEvaluations(moduleForm); track evaluationForm.controls.id.value) {
                    <li
                      cdkDrag
                      [attr.data-evaluation-card-id]="evaluationForm.controls.id.value"
                      cdkDragLockAxis="y"
                      class="drag-sort-item block w-full"
                      [cdkDragData]="evaluationForm"
                      (cdkDragStarted)="onDragStartedForEvaluation(moduleForm.controls.id.value, evaluationForm.controls.id.value)"
                      (cdkDragEnded)="onEvaluationDragEnded(moduleForm.controls.id.value)"
                    >
                      <l-sortable-card
                        [active]="isEvaluationCardActive(evaluationForm.controls.id.value)"
                        [dragging]="isDraggingEvaluation(moduleForm.controls.id.value, evaluationForm.controls.id.value)"
                        [clickable]="true"
                        dragHandleAriaLabel="Reordenar avaliação"
                        (cardClick)="setActiveEvaluationCard(evaluationForm.controls.id.value)"
                      >
                        <span class="shrink-0 text-sm font-medium text-lGray50">
                          Avaliação {{ getEvaluationDisplayIndex(moduleForm.controls.id.value, evaluationForm.controls.id.value) }}
                        </span>

                        <div sortableCardActions>
                          @if (isEvaluationCardActive(evaluationForm.controls.id.value)) {
                            <button
                              type="button"
                              class="flex shrink-0 items-center justify-center text-lWhite transition-opacity hover:opacity-80"
                              aria-label="Editar avaliação"
                              (click)="setActiveEvaluationCard(evaluationForm.controls.id.value); $event.stopPropagation()"
                            >
                              <l-icon class="text-2xl">edit</l-icon>
                            </button>
                          } @else {
                            <button
                              type="button"
                              class="flex shrink-0 items-center justify-center text-lDanger transition-opacity hover:opacity-80"
                              aria-label="Excluir avaliação"
                              (click)="onDeleteEvaluation(moduleForm, evaluationForm.controls.id.value); $event.stopPropagation()"
                            >
                              <l-icon class="text-xl">delete</l-icon>
                            </button>
                          }
                        </div>
                      </l-sortable-card>

                      <ng-template cdkDragPlaceholder>
                        <l-sortable-card [ghost]="true" dragHandleAriaLabel="Reordenar avaliação">
                          <span class="shrink-0 text-sm font-medium text-lGray50">
                            Avaliação {{ getEvaluationDisplayIndex(moduleForm.controls.id.value, evaluationForm.controls.id.value) }}
                          </span>
                          <span
                            sortableCardActions
                            class="invisible flex shrink-0 items-center justify-center text-lDanger"
                            aria-hidden="true"
                          >
                            <l-icon class="text-xl">delete</l-icon>
                          </span>
                        </l-sortable-card>
                      </ng-template>

                      <ng-template cdkDragPreview matchSize>
                        <l-sortable-card [preview]="true" dragHandleAriaLabel="Reordenar avaliação">
                          <span class="shrink-0 text-sm font-medium text-lGray50">
                            Avaliação {{ getEvaluationDisplayIndex(moduleForm.controls.id.value, evaluationForm.controls.id.value) }}
                          </span>
                          <span
                            sortableCardActions
                            class="flex shrink-0 items-center justify-center text-lDanger"
                            aria-hidden="true"
                          >
                            <l-icon class="text-xl">delete</l-icon>
                          </span>
                        </l-sortable-card>
                      </ng-template>
                    </li>
                  }
                </ul>
              }

              <div class="flex w-full flex-col gap-4 md:flex-row">
                <button
                  type="button"
                  class="inline-flex h-12 flex-1 items-center justify-center gap-1.5 rounded-3xl bg-lPrimary px-4 text-base font-medium leading-6 text-white transition duration-200 hover:brightness-105 active:brightness-95"
                  (click)="onAddContent(moduleForm)"
                >
                  Adicionar conteúdo
                  <span class="text-xl font-normal leading-none" aria-hidden="true">+</span>
                </button>

                <button
                  type="button"
                  class="inline-flex h-12 flex-1 items-center justify-center gap-1.5 rounded-3xl bg-lGray50 px-4 text-base font-medium leading-6 text-lBlack transition duration-200 hover:brightness-105 active:brightness-95"
                  (click)="onAddEvaluation(moduleForm)"
                >
                  Adicionar avaliação
                  <span class="text-xl font-normal leading-none" aria-hidden="true">+</span>
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </article>
    }
  </div>
</section>
